import state from './informacastrecipientgroup.state'
import mutations from './informacastrecipientgroup.mutations'
import actions from './informacastrecipientgroup.actions'

export default {
  state,
  mutations,
  actions
}
